module.exports = __webpack_public_path__ + "static/media/mari_tile.d758b5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_tile.png
// module id = 105
// module chunks = 0